import { render } from "./DisplayBox.vue?vue&type=template&id=18dc1b06"
import script from "./DisplayBox.vue?vue&type=script&lang=js"
export * from "./DisplayBox.vue?vue&type=script&lang=js"

import "./DisplayBox.vue?vue&type=style&index=0&id=18dc1b06&scpoed=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__